var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateTPAParams } from './generateTPAParams';
import { getProcessor } from './processor';
import { defaultOptions, plugins } from './common';
function escapeRegExp(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
export function getProcessedCssWithVars(dynamicExpressions, cssVars, _a, options, defaults) {
    var siteColors = _a.siteColors, siteTextPresets = _a.siteTextPresets, styleParams = _a.styleParams;
    options = __assign(__assign({}, defaultOptions), (options || {}));
    var tpaParams = generateTPAParams({ siteColors: siteColors, siteTextPresets: siteTextPresets, styleParams: styleParams, options: options, defaults: defaults });
    var processor = getProcessor({ cssVars: cssVars, plugins: plugins });
    return Object.keys(dynamicExpressions).reduce(function (obj, key) {
        var _a;
        var newValue;
        newValue = processor.process({
            part: dynamicExpressions[key],
            tpaParams: tpaParams,
        });
        return __assign(__assign({}, obj), (_a = {}, _a[key] = newValue, _a));
    }, {});
}
export function getProcessedCssWithConfig(processedCssConfig, _a, options) {
    var siteColors = _a.siteColors, siteTextPresets = _a.siteTextPresets, styleParams = _a.styleParams;
    options = __assign(__assign({}, defaultOptions), (options || {}));
    if (!processedCssConfig.css) {
        return '';
    }
    var prefixedCss = processedCssConfig.css.replace(new RegExp(processedCssConfig.compilationHash, 'g'), options.prefixSelector ? "".concat(options.prefixSelector) : '');
    var tpaParams = generateTPAParams({ siteColors: siteColors, siteTextPresets: siteTextPresets, styleParams: styleParams, options: options, defaults: processedCssConfig.defaults });
    var processor = getProcessor({ cssVars: processedCssConfig.cssVars, plugins: plugins });
    return processedCssConfig.customSyntaxStrs.reduce(function (processedContent, part) {
        var newValue;
        try {
            newValue = processor.process({ part: part, tpaParams: tpaParams });
        }
        catch (e) {
            if (processedCssConfig.isSrictModeDisabled || !options.strictMode) {
                newValue = '';
            }
            else {
                throw e;
            }
        }
        return processedContent.replace(new RegExp(escapeRegExp(part), 'g'), newValue);
    }, prefixedCss);
}
export function getStaticCssWithConfig(staticCssConfig, _a) {
    var _b = _a === void 0 ? { prefixSelector: '' } : _a, prefixSelector = _b.prefixSelector;
    var prefixedCss = (staticCssConfig.staticCss || '').replace(new RegExp(staticCssConfig.compilationHash, 'g'), prefixSelector);
    return prefixedCss;
}
export function getBuildTimeStaticCss(staticCssConfig) {
    var prefixedCss = (staticCssConfig.staticCss || '').replace(new RegExp(staticCssConfig.compilationHash, 'g'), '');
    return { css: prefixedCss, hash: staticCssConfig.staticCssHash };
}
export { getSiteCssVariables, getComponentCssVariables } from './css-variables';
export { generateTPAParamsFromStyleParams } from './generateTPAParams';
//# sourceMappingURL=standalone.js.map